import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import find from 'lodash/find';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import constants from 'yoda-core-components/lib/common/Constants';
import {
    LOCATION_SERVICE_COOKIES_USER_PREFERRED_STORE,
    LOCATION_SERVICE_COOKIES_AKAMAI_STORE,
} from '../../common/Constants';
import ProductConstants from '../../common/ProductConstants';
import PricingInfo from '../PricingInfo/PricingInfo';
import pricingAction from '../../actions/ProductPricingAction';
import bopisMessageAction from '../../actions/BOPISMessageAction';
import { initProductOptions } from '../../selectors/ProductOptionsSelector';
import selectProductType from '../../selectors/productDetails/selectProductType';
import selectPricingFallbackCallError from '../../selectors/pricing/selectPricingFallbackCallError';
import productFinalPriceAfterCoupon from '../../selectors/ProductFinalPriceSelector';
import getBOPISMessage from '../../selectors/BOPISMessageSelector';
import { selectInventoryWrapper } from '../../selectors/PdpNameSpaceSelector';

/* istanbul ignore next */
export class ProductPricing extends Component {
    static defaultProps = {
        productOptions: {},
        itemOfferings: {},
        customOptions: {},
        selectedStore: {},
        inventory: [],
        productType: {},
        regionZone: null,
        pricingFallbackCallError: false,
        isSticky: false,
        fromMiniPDP: false,
        featureFlags: {},
        userStore: {},
        couponPriceDetails: {},
        bopisMessage: null,
        akZip: Cookies.load('ak_zip') || '',
        deviceType: {},
        shouldShortenPrice: false,
        fpacPriceIndicator: false,
    };

    static propTypes = {
        pricingDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        itemOfferings: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        customOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedStore: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        userStore: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        ppId: PropTypes.string.isRequired,
        productType: PropTypes.object,
        inventory: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        regionZone: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        pricingFallbackCallError: PropTypes.bool,
        isSticky: PropTypes.bool,
        fromMiniPDP: PropTypes.bool,
        featureFlags: PropTypes.object,
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        couponPriceDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        bopisMessage: PropTypes.string,
        akZip: PropTypes.string,
        deviceType: PropTypes.object,
        shouldShortenPrice: PropTypes.bool,
        fpacPriceIndicator: PropTypes.bool,
    };

    componentDidMount() {
        if (this.props.regionZone !== null && !this.props.isSticky) {
            this.fetchPricing(this.props);
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            isSticky,
            regionZone,
            fromMiniPDP,
            featureFlags,
            itemOfferings,
            selectedStore,
            actions = {},
            customOptions,
            userStore,
            ppId,
            inventory,
        } = this.props;

        const {
            userStore: userStoreNextProps,
            itemOfferings: itemOfferingsNextProps,
            customOptions: customOptionsNextProps,
        } = nextProps;

        const itemOfferingsNextPropsURL = get(itemOfferingsNextProps, 'URL', '');
        const itemOfferingsURL = get(itemOfferings, 'URL', '');
        const customOptionsNextPropsURL = get(customOptionsNextProps, 'pricingURL.URL', '');
        const customOptionsURL = get(customOptions, 'pricingURL.URL', '');
        const warehouseClass = get(
            nextProps.productOptions,
            'selectedProductLot[0].warehouseClassCode',
            ''
        );
        let storesId = '';
        let params = {};

        if (isSticky) {
            return null;
        }

        if (nextProps.regionZone !== regionZone) {
            return this.fetchPricing(nextProps);
        }

        storesId = nextProps.selectedStore.id;

        params = {
            stores: storesId,
        };

        if (nextProps.regionZone) {
            params.regionId = nextProps.regionZone;
        }
        const customizationType = get(
            nextProps.productOptions,
            'selectedProductLot[0].customizationModel.type',
            ''
        );
        const nextPropsisCustomOption =
            customizationType === ProductConstants.MADE_TO_MEASURE ||
            customizationType === ProductConstants.HEMMING;

        const modifiedCustomOptions = [];
        if (
            nextPropsisCustomOption &&
            customOptionsNextProps.options &&
            customOptionsNextProps.selectedCustomOptions
        ) {
            // to seggregate list of mandatory custom options
            const mandatoryCustomOptions = filter(
                customOptionsNextProps.options.fields,
                'required'
            );
            mandatoryCustomOptions.forEach((option) => {
                const nextCustomOption = find(
                    customOptionsNextProps.selectedCustomOptions,
                    (o) => o.type === option.name
                );
                const customOption = find(
                    customOptions.selectedCustomOptions,
                    (o) => o.type === option.name
                );
                if (customOption && customOption.value !== nextCustomOption.value) {
                    // to identify if any custom options were modified by an user action
                    modifiedCustomOptions.push(nextCustomOption.type);
                }
            });
        }

        if (nextProps.itemOfferings) {
            params.delivery = nextProps.itemOfferings.isTruckable ? 'TRUCK' : 'STANDARD';
            if (nextProps.itemOfferings.productSubdivision) {
                params.subdivision = nextProps.itemOfferings.productSubdivision;
            }
            if (nextProps.itemOfferings.holidayName) {
                params.occasionName = nextProps.itemOfferings.holidayName;
            }
        }

        if (
            nextProps.itemOfferings.itemOfferingCall &&
            !nextPropsisCustomOption &&
            (nextProps.itemOfferings.URL !== itemOfferings.URL ||
                nextProps.selectedStore.id !== selectedStore.id ||
                !isEqual(userStoreNextProps, userStore) ||
                nextProps.itemOfferings.isTruckable !== itemOfferings.isTruckable ||
                nextProps.itemOfferings.productSubdivision !== itemOfferings.productSubdivision ||
                nextProps.itemOfferings.holidayName !== itemOfferings.holidayName)
        ) {
            const singleDeliveryDateZipcode = this.getSingleDeliveryDateZipcode();
            if (singleDeliveryDateZipcode) {
                params.zipCode = singleDeliveryDateZipcode;
            }
            const bopisZipcode = this.getBopisInventoryCheckZipcode();
            if (bopisZipcode) {
                params.bopisZipcode = bopisZipcode;
            }
            if (featureFlags.enableBOPISDynamicMessage && !this.props.bopisMessage) {
                actions.getBOPISMessage();
            }
            actions.getProductPricingAction({
                url: nextProps.itemOfferings.URL,
                params,
                warehouseClass,
                promiseAPI: !fromMiniPDP,
                fromMiniPDP,
            });
            /* istanbul ignore next */
        } else if (
            nextProps.customOptions.pricingURL &&
            nextProps.itemOfferings.itemOfferingCall &&
            nextPropsisCustomOption &&
            nextProps.customOptions.pricingURL.itemOfferingCall &&
            (nextProps.selectedStore.id !== selectedStore.id ||
                nextProps.userStore !== userStore ||
                itemOfferingsNextPropsURL !== itemOfferingsURL ||
                customOptionsNextPropsURL !== customOptionsURL ||
                // if any mandatory custom option is modified then make sku-offerings call
                !isEmpty(modifiedCustomOptions))
        ) {
            // When customizationType is Hemming the product doesn't need qparams or store ids
            if (customizationType !== ProductConstants.HEMMING) {
                params = nextProps.customOptions.pricingURL
                    ? {
                          stores: storesId,
                          ...nextProps.customOptions.pricingURL.qparams,
                      }
                    : { stores: storesId };
            }
            const singleDeliveryDateZipcode = this.getSingleDeliveryDateZipcode();
            if (singleDeliveryDateZipcode) {
                params.zipCode = singleDeliveryDateZipcode;
            }
            const bopisZipcode = this.getBopisInventoryCheckZipcode();
            if (bopisZipcode) {
                params.bopisZipcode = bopisZipcode;
            }
            actions.getProductPricingAction({
                url: itemOfferingsNextPropsURL,
                params,
                warehouseClass,
                promiseAPI: !fromMiniPDP,
                fromMiniPDP,
            });
        } else if (nextProps.itemOfferings.itemOfferingCall !== itemOfferings.itemOfferingCall) {
            actions.clearProductPricingAction(fromMiniPDP);
        }

        if (
            nextProps.inventory[0] &&
            !nextProps.inventory[0].lotPrice &&
            inventory !== nextProps.inventory
        ) {
            actions.getProductPricingFallbackAction(ppId, fromMiniPDP);
        }

        return true;
    }

    shouldComponentUpdate(nextProps) {
        const {
            pricingDetails = {},
            productOptions: { isProductInStock } = {},
            shouldShortenPrice,
        } = this.props;
        if (
            nextProps?.pricingDetails?.defaults &&
            !isEqual(nextProps?.pricingDetails, pricingDetails)
        ) {
            return true;
        }

        if (nextProps?.productOptions?.isProductInStock !== isProductInStock) {
            return true;
        }

        if (nextProps?.shouldShortenPrice !== shouldShortenPrice) return true;

        return false;
    }

    getSingleDeliveryDateZipcode = () => {
        let singleDeliveryDateZipcode = '';
        const {
            featureFlags: { enablePromiseZipcodePrecedence = true },
        } = this.props;
        const userDefaultAddressZip = Cookies.load(constants.DP_USER_DEFAULT_ADDRESS_ZIP);
        if (userDefaultAddressZip && enablePromiseZipcodePrecedence) {
            singleDeliveryDateZipcode = userDefaultAddressZip;
        } else {
            const userPreferredStore = Cookies.load('userPreferredStore');
            const { inputZipCode = '', zipcode = '' } = userPreferredStore
                ? JSON.parse(userPreferredStore)
                : {};
            if (userPreferredStore && inputZipCode && enablePromiseZipcodePrecedence) {
                singleDeliveryDateZipcode = inputZipCode;
            } else if (userPreferredStore && zipcode && !enablePromiseZipcodePrecedence) {
                singleDeliveryDateZipcode = zipcode;
            } else {
                singleDeliveryDateZipcode = this.props.akZip;
            }
        }
        return singleDeliveryDateZipcode;
    };

    getBopisInventoryCheckZipcode = () => {
        const {
            fromMiniPDP = false,
            featureFlags: { enablePromiseZipcodePrecedence = true },
        } = this.props;
        let bopisZipcode = '';
        if (fromMiniPDP || !enablePromiseZipcodePrecedence) {
            return null;
        }
        const userPreferredStore = Cookies.load(LOCATION_SERVICE_COOKIES_USER_PREFERRED_STORE);
        const { inputZipCode = '', zipcode = '' } = userPreferredStore
            ? JSON.parse(userPreferredStore)
            : {};
        if (inputZipCode) {
            bopisZipcode = inputZipCode;
        } else if (zipcode) {
            bopisZipcode = zipcode;
        }
        return bopisZipcode;
    };

    fetchPricing = (props) => {
        const { fromMiniPDP, productOptions } = props;
        const SDPUStoreInfo = LocalStorage.getData('SDPUStoreInfo', true);
        const galleryStoreInfo = LocalStorage.getData('gallerySDPUStoreInfo', true);
        const akamaiStore = Cookies.load(LOCATION_SERVICE_COOKIES_AKAMAI_STORE);
        const userPreferredStore = Cookies.load(LOCATION_SERVICE_COOKIES_USER_PREFERRED_STORE);
        // when user has a store then pricing call will be made in componentWillReceiveProps along with store information. Not applicable to mini-pdp
        const hasStore = SDPUStoreInfo || galleryStoreInfo || akamaiStore || userPreferredStore;
        const warehouseClass = get(productOptions, 'selectedProductLot[0].warehouseClassCode', '');

        if (
            props.itemOfferings.itemOfferingCall &&
            !props.itemOfferings.isCustomOption &&
            (!hasStore || fromMiniPDP)
        ) {
            const requestParams = {};
            const singleDeliveryDateZipcode = this.getSingleDeliveryDateZipcode();
            if (singleDeliveryDateZipcode) {
                requestParams.zipCode = singleDeliveryDateZipcode;
            }
            const bopisZipcode = this.getBopisInventoryCheckZipcode();
            if (bopisZipcode) {
                requestParams.bopisZipcode = bopisZipcode;
            }
            /* istanbul ignore next */
            if (props.selectedStore.id) {
                requestParams.stores = props.selectedStore.id;
                /* istanbul ignore next */
            } else if (props.userStore && props.userStore.length && props.userStore[0].id) {
                requestParams.stores = props.userStore[0].id;
            }

            if (props.regionZone) {
                requestParams.regionId = props.regionZone;
            }
            requestParams.delivery = props.itemOfferings.isTruckable ? 'TRUCK' : 'STANDARD';
            if (props.itemOfferings) {
                if (props.itemOfferings.productSubdivision) {
                    requestParams.subdivision = props.itemOfferings.productSubdivision;
                }
                if (props.itemOfferings.holidayName) {
                    requestParams.occasionName = props.itemOfferings.holidayName;
                }
            }

            props.actions.getProductPricingAction({
                url: this.props.itemOfferings.URL,
                params: requestParams,
                warehouseClass,
                promiseAPI: !fromMiniPDP,
                fromMiniPDP,
            });
        }
    };

    render() {
        const {
            pricingDetails = {},
            pricingFallbackCallError,
            isSticky,
            productOptions: { isProductInStock },
            couponPriceDetails,
            featureFlags,
            fromMiniPDP,
            deviceType,
            shouldShortenPrice,
            fpacPriceIndicator,
            couponExclusionMessage,
            productType: { templateType },
        } = this.props;

        return (
            <PricingInfo
                pricingDetails={pricingDetails}
                productType={templateType}
                priceInBag={pricingFallbackCallError}
                isSticky={isSticky}
                isProductInStock={isProductInStock}
                couponPriceDetails={couponPriceDetails}
                featureFlags={featureFlags}
                fromMiniPDP={fromMiniPDP}
                deviceType={deviceType}
                shouldShortenPrice={shouldShortenPrice}
                fpacPriceIndicator={fpacPriceIndicator}
                couponExclusionMessage={couponExclusionMessage}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    itemOfferings: initProductOptions(ownProps.fromMiniPDP)(state).pricingURL,
    productOptions: initProductOptions(ownProps.fromMiniPDP)(state),
    inventory: selectInventoryWrapper(ownProps.fromMiniPDP)(state),
    customOptions: state.customOptions,
    pricingFallbackCallError: selectPricingFallbackCallError(state),
    productType: selectProductType(ownProps.fromMiniPDP)(state),
    selectedStore:
        state.selectedStore && state.selectedStore.storeDetails
            ? state.selectedStore.storeDetails
            : {},
    userStore:
        state.selectedStore && state.selectedStore.userStores ? state.selectedStore.userStores : {},
    regionZone: 0,
    featureFlags: state.context ? state.context.featureFlags : {},
    couponPriceDetails: productFinalPriceAfterCoupon(ownProps.fromMiniPDP)(state),
    bopisMessage: getBOPISMessage(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...pricingAction,
            ...bopisMessageAction,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductPricing);
